mutation Inertia_ImportOrder(
  $companyId: ID!
  $agentRegistrationId: ID!
  $officerId: ID
  $externalFileNumber: String!
  $verificationEnabled: Boolean!
  $documentEmailEnabled: Boolean!
  $rawSnapshot: JSON!
  $parties: [ImportPartyInput!]!
  $documents: [ImportDocumentInput!]!
  $sourceAttachmentTree: JSON
) {
  importOrder(input: {
    companyId: $companyId
    agentRegistrationId: $agentRegistrationId
    officerId: $officerId
    externalFileNumber: $externalFileNumber
    verificationEnabled: $verificationEnabled
    documentEmailEnabled: $documentEmailEnabled
    rawSnapshot: $rawSnapshot
    parties: $parties
    documents: $documents
    sourceAttachmentTree: $sourceAttachmentTree
  }) {
    order {
      gid
    }
    errors
  }
}
